// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__yp1sj","tableHeaderContainer":"styles_tableHeaderContainer__2zcPe","tableRow":"styles_tableRow__3AOkk","highlighted":"styles_highlighted__3oMfW"};